import { Trash2 } from "lucide-react";

const HEADERS = [
  "ID",
  "File Name",
  "Size",
  "Uploaded At",
  "Uploaded By",
  "Actions",
];

const formatSize = (bytes) => {
  if (bytes == null) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};

const formatDate = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleString("en-IN", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  } catch {
    return "—";
  }
};

const formatUploader = (uploader) => {
  if (!uploader) return "—";
  const { first_name, last_name, auth } = uploader;
  if (first_name && last_name) return `${first_name} ${last_name}`;
  return first_name || auth?.username || "—";
};

const DocumentsTable = ({ documents = [], onDelete, readOnly = false }) => {
  return (
    <div className="w-full bg-white shadow rounded-lg overflow-hidden">
      <div className="max-h-[600px] overflow-y-auto overflow-x-auto">
        <table className="w-full table-auto border-collapse min-w-[900px]">
          <thead className="sticky top-0 z-10">
            <tr className="bg-white border-b text-[10px] tracking-widest text-gray-500 uppercase">
              {HEADERS.map((h) => (
                <th
                  key={h}
                  className="px-3 py-2 text-center font-semibold whitespace-nowrap"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {documents.length === 0 ? (
              <tr>
                <td
                  colSpan={HEADERS.length}
                  className="py-10 text-center text-gray-400 text-xs"
                >
                  No documents found.
                </td>
              </tr>
            ) : (
              documents.map((doc, index) => {
                const rowBg = index % 2 === 0 ? "bg-gray-50" : "bg-white";
                return (
                  <tr
                    key={doc.id}
                    className={`${rowBg} hover:bg-blue-50 transition-colors`}
                  >
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-500">
                      {doc.id}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-900">
                      {doc.document_name || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700">
                      {formatSize(doc.file_size)}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-500">
                      {formatDate(doc.uploaded_at)}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700">
                      {formatUploader(doc.uploader)}
                    </td>
                    <td className="px-3 py-2 text-center whitespace-nowrap">
                      {readOnly ? (
                        <span className="text-[10px] text-gray-400">—</span>
                      ) : (
                        <div className="flex justify-center">
                          <Trash2
                            className="w-4 h-4 text-red-400 hover:text-red-600 cursor-pointer transition-colors"
                            title="Delete document"
                            onClick={() => onDelete?.(doc.id, doc.document_name)}
                          />
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DocumentsTable;
